export default __webpack_public_path__ + "images/assets/cbd29fb1d3570c0cddc44595297c5301.svg";